module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMA/wD/AP83WBt9AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAI0lEQVR42mP8//8/AymAiYFEQHsNjAyh9UPdD8NBA+MwSEsAexwG7EZWZCoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_apa.png
// module id = B/FD
// module chunks = 0